import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle, Leaf, Sparkles } from 'lucide-react';

const WelcomeSection = () => {
  const features = [
    {
      icon: <Sparkles className="w-8 h-8 text-[#008000]" />,
      title: 'Tailored End-to-End Solutions',
      description: 'We offer personalized services from conceptual design to project completion, ensuring your unique needs are met.',
    },
    {
      icon: <Leaf className="w-8 h-8 text-[#008000]" />,
      title: 'Harmonizing Architecture with Environment',
      description: 'Our innovative and sustainable designs reflect your identity while blending seamlessly with the surroundings.',
    },
    {
      icon: <CheckCircle className="w-8 h-8 text-[#008000]" />,
      title: 'Focus on Functional & Beautiful Interiors',
      description: 'Our interior design services prioritize functionality and beauty, creating spaces that are comfortable and visually appealing.',
    },
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-[#ffffff] via-[#e8f5e9] to-[#c8e6c9]">
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="space-y-6"
          >
            <div>
              <p className="text-sm font-semibold text-[#008000] tracking-wider uppercase mb-2">
                ARCHITECTURAL AND INTERIOR DESIGN EXCELLENCE
              </p>
              <h2 className="text-4xl md:text-5xl font-bold text-gray-900 leading-tight">
                Welcome to FCV Constructions
              </h2>
            </div>
            <p className="text-lg text-gray-700 leading-relaxed">
              Creating Dream Spaces with Creativity, Functionality, and Sustainability
            </p>
          </motion.div>

          {/* Right Content - Features */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="space-y-6"
          >
            {features.map((feature, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.2, duration: 0.5 }}
                viewport={{ once: true }}
                className="flex gap-4 bg-white/90 backdrop-blur-sm p-6 rounded-lg shadow-md hover:shadow-xl transition-all duration-300 group"
              >
                <div className="flex-shrink-0">
                  <div className="w-12 h-12 bg-[#E8F5E9] rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                    {feature.icon}
                  </div>
                </div>
                <div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">{feature.title}</h3>
                  <p className="text-gray-700 text-sm leading-relaxed">{feature.description}</p>
                </div>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default WelcomeSection;